<template lang="pug">
  LayoutDefault
    .page: .container-fluid
      .section  
        .mar_b--20
          .card: .card--body
            .row.no-gutters.align-items-center
              .col-auto
                .support--manual-icon
                  span
              .col
                .support--manual-title Online Platform User's Guide
                .support--manual-action
                  span.hidden_sm.mar_r--10.hidden_md
                    button.button.button-neutral.button_standard(@click="OPEN_MANUAL_MODAL")
                      | View in browser
                      span.ml-2: i.fas.fa-eye

                  a.button.button-neutral.button_standard(:href="filePath", target="_blank")
                    | Download User's Guide
                    span.ml-2: i.fas.fa-download
          
        .row.row-eq-height
          .col-xl-3.col-sm-6
            .card: .card--body
              .support--card.align__center
                .support--card-img.mouse
                .support--card-title
                  | Online
                .support--card-description
                  | Provide us with your contact details, and we’ll be in touch soon

          .col-xl-3.col-sm-6.pad_t--20-xsm
            .card: .card--body
              .support--card.align__center
                .support--card-img.whatsapp
                .support--card-title
                  | WhatsApp
                .support--card-description
                  | Send us a message at +6011 6508 5288 during office hours

          .col-xl-3.col-sm-6.pad_t--20-lg
            .card: .card--body
              .support--card.align__center
                .support--card-img.phone
                .support--card-title
                  | Phone
                .support--card-description
                  | Call us at +603 2177 1333 during office hours

          .col-xl-3.col-sm-6.pad_t--20-lg
            .card: .card--body
              .support--card.align__center
                .support--card-img.facetoface
                .support--card-title
                  | Face-to-face
                .support--card-description
                  | To find out our branch that is nearest to you, click <a href="//einvest.affinhwang.com/branches" target="_blank">here</a>.

        
        b-modal(ref='user_manual_modal', hide-footer, hide-header, size="xl")
          .modal--container.no_padding
            ModalClose(@click.native="CLOSE_MANUAL_MODAL")
            .embed-responsive.embed-responsive-16by9
              embed.embed-responsive-item(:src="filePath" type="application/pdf" width="100%")
</template>



<script>
import filesInCMS from '@/lib/filesInCMS';
import ModalClose from '../components/ModalClose';

export default {
  name: 'Support',
  mixins: [],
  components: { 
    ModalClose
  },

  data() {
    return {
      filePath: filesInCMS.support.userGuide
    }
  },

  methods: {
    OPEN_MANUAL_MODAL() {
      this.$refs.user_manual_modal.show();
    },
    CLOSE_MANUAL_MODAL() {
      this.$refs.user_manual_modal.hide();
    },
  },
}

</script>




<style lang="scss">
.support--card {
  @include font-size($page-card);
  padding: 20px 0;
}
.support--card-img {
  height: 90px;
  width: 100%;
  margin-bottom: 25px;

  @each $bg in mouse, phone, whatsapp, facetoface{
    &.#{$bg} {
      background: url('../assets/images/support--#{$bg}.png') no-repeat center center;
      background-size: auto 90px;
      
      @include MQ(SM) {
        background-size: auto 45px;
      }
    }
  }

  @include MQ(MD) {
    margin-bottom: 20px;
  }

  @include MQ(SM) {
    height: 45px;
    margin-bottom: 15px;
  }
  @include MQ(XS) {
    margin-bottom: 10px;
  }
}

.support--card-title {
  text-transform: uppercase;
  color: $color-primary;
  @include primaryFont700;
}

.support--card-description {
  padding-top: 15px;

  @include MQ(SM) {
    padding-top: 10px;
  }

  @include MQ(XS) {
    padding-top: 5px;
  }
}	


.support--manual-icon {
  color: $color-primary_light;
  margin: 0 40px 0 20px;
  
  span {
    display: inline-block;
    width: 103px;
    height: 80px;
    background: url('../assets/images/manual.jpg') no-repeat center center;
    background-size: 103px 80px;
  }
}
.support--manual-title {
  color: $color-primary;
  @include primaryFont600;
  font-size: 130%;
  padding-bottom: 10px;
}
.support--manual-action {

}
</style>
